import React from 'react'
import { motion } from 'framer-motion'
import { DropDown } from '../../globalComponents/DropDown'
import { userInfo } from '../../globalComponents/slice/userDataSlice'
import { InputDiv, TextInput } from '../../globalComponents/TextInput'
import { LoggerButton } from '../../globalComponents/Button'
import { IoLocation } from 'react-icons/io5'
import { NotificationAlert } from '../../utils/NotificationAlert'
import { useQuery, useLazyQuery } from '@apollo/client'
import { GET_SERVICE_TYPES, SERVICES_SEARCH } from '../../app/apollo/index'
import {
  componentTransition,
  componentTransitionProp,
} from '../../animation/index'
import { useHistory } from 'react-router-dom'
import countryList from 'react-select-country-list'
import { useAppSelector } from '../../app/hooks'
import { Row, Col, Pagination } from 'antd'
import { BigContentContainer, Label } from '../../globalComponents/globalStyle'
import { Dropdown, Option, ServiceCard, IDAvatar } from './Styles'
import { Text } from '../Education/style'
import { FilterContainer, MobileFilter } from '../Accomodation/style'
import { IoIosFunnel } from 'react-icons/io'
import { StyledDrawer } from '../../globalComponents/AppLayout'
const Services = () => {
  const [loadingstate, setLoading] = React.useState(false)

  const options = React.useMemo(() => countryList().getData(), [])
  const [country, setCountry] = React.useState<any>('')
  const [defaultCountry, setDefaultCountry] = React.useState()
  const userDetails = useAppSelector(userInfo)
  const [drawerVisible, setDrawerVisible] = React.useState(false)
  const { data, loading: queryLoading, error } = useQuery(GET_SERVICE_TYPES)
  const [getServices, getServicesData] = useLazyQuery(SERVICES_SEARCH, {
    // fetchPolicy: "cache-and-network",
  })

  const [servicesList, setServicesList] = React.useState<any>()
  const [businessName, setBusinessName] = React.useState<any>('')
  const [city, setCity] = React.useState<any>('')
  const [category, setCategory] = React.useState<any>('')
  const [categoryList, setCategoryList] = React.useState<any>([])
  const [currentPage, setCurrentPage] = React.useState<any>(1)
  const [allPages, setAllPages] = React.useState<any>()
  // console.log("services types", data?.getServiceCategory);
  React.useEffect(() => {
    setCategoryList(data?.getServiceCategory)
  }, [data])
  // console.log("user details", userDetails);
  React.useEffect(() => {
    setDefaultCountry(userDetails?.currentCountry?.country)
  }, [userDetails])
  React.useEffect(() => {
    if (getServicesData?.error) {
      setLoading(false)
      NotificationAlert('error', 'Error occured', 'Try Again')
    } else if (getServicesData?.data?.getServices) {
      setLoading(false)
      setDrawerVisible(false)
      setServicesList(getServicesData?.data?.getServices?.Service)
      setAllPages(getServicesData?.data?.getServices?.last_page)
    } else if (getServicesData?.loading === true) {
      setLoading(true)
    }
  }, [getServicesData])
  console.log('services list', servicesList)
  // React.useEffect(() => {
  //   console.log("loading state", loadingstate);
  // }, [loadingstate]);
  const history = useHistory()
  const handleServiceSearch = async (
    country?: any,
    serviceCategory?: any,
    name?: any,
    city?: any,
    current?: any,
  ) => {
    setServicesList([])
    try {
      getServices({
        variables: {
          byCountry: country,
          byName: name,
          byServiceCategory: Number(serviceCategory),
          byCity: city,
          requestedPage: current,
        },
      })
      // console.log(category);
    } catch (e) {
      NotificationAlert('error', 'Error occured', 'Try Again')
      console.log(e)
      // setLoading(false);
    }
  }
  console.log('getServicesData', getServicesData)
  React.useEffect(() => {
    handleServiceSearch(defaultCountry, '', '', '', currentPage)
  }, [defaultCountry])
  const list = (
    <Row>
      {servicesList?.map((service: any, id: any) => (
        <Col
          xs={{ span: 24 }}
          onClick={() =>
            history.push({
              pathname: `/home/services/details`,
              state: { service },
            })
          }
          key={id}
          style={{ marginBottom: '15px' }}
          md={{ span: 8 }}
        >
          <ServiceCard>
            <div>
              <IDAvatar>{service?.name.charAt(0)}</IDAvatar>
              <h5 className="title-medium">{service?.name}</h5>
            </div>

            <div
              style={{
                display: 'flex',
                marginTop: '10px',
                alignItems: 'baseline',
                padding: ' 0 0 0 10px',
              }}
            >
              <IoLocation style={{ margin: 0 }} />
              <h4 className="title-medium">
                {service?.location[0]?.locationName}
              </h4>
            </div>
          </ServiceCard>
        </Col>
      ))}
    </Row>
  )
  const handleBackChange = () => {
    if (currentPage > 1) {
      handleServiceSearch(
        country,
        category,
        businessName,
        city,
        currentPage - 1,
      )
      setCurrentPage(currentPage - 1)
    }
  }
  const handleForwardChange = () => {
    if (currentPage < allPages) {
      handleServiceSearch(
        country,
        category,
        businessName,
        city,
        currentPage + 1,
      )
      setCurrentPage(currentPage + 1)
    }
  }
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === 'prev') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={handleBackChange}>
          Previous
        </h5>
      )
    }
    if (type === 'next') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      )
    }
    return originalElement
  }
  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <BigContentContainer>
        <StyledDrawer
          bodyStyle={{ padding: '0px' }}
          closable={false}
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          placement="right"
          key="bottom"
        >
          <FilterContainer style={{ height: '100%', display: 'block' }}>
            <div>
              <h3>Filter services by:</h3>
              <Label>
                <h3> Country</h3>
              </Label>
              <DropDown
                values={options}
                onChange={(e) => setCountry(e.target.value)}
              />
              <br />
              <Label>
                <h3> Service category</h3>
              </Label>
              <InputDiv>
                <Dropdown onChange={(e: any) => setCategory(e.target.value)}>
                  <Option value="">All Category</Option>
                  {categoryList?.map((categories: any) => (
                    <Option key={categories.id} value={categories.id}>
                      {categories.serviceCategory}
                    </Option>
                  ))}
                </Dropdown>
              </InputDiv>
              <br />
              <Label>
                <h3> Business Name</h3>
              </Label>
              <TextInput
                placeholder="Type service name here..."
                onChange={(e: any) => setBusinessName(e.target.value)}
              />
              <br />
              <Label>
                <h3>City/State</h3>
              </Label>
              <TextInput
                placeholder="Type city/state name here..."
                onChange={(e: any) => setCity(e.target.value)}
              />
              <br />
              <LoggerButton
                loading={loadingstate}
                onClick={() =>
                  handleServiceSearch(
                    country,
                    category,
                    businessName,
                    city,
                    currentPage,
                  )
                }
                text="Search.."
              />
            </div>
          </FilterContainer>
        </StyledDrawer>
        <Text>You can search through our list of available services...</Text>{' '}
        <MobileFilter onClick={() => setDrawerVisible(true)}>
          search for services.
          <div>
            <IoIosFunnel />
          </div>
        </MobileFilter>
        {loadingstate && <Text>loading... please wait</Text>}{' '}
        {getServicesData?.data?.getServices?.length === 0 && (
          <Text>No match found</Text>
        )}
        <Row style={{ height: '100%' }} justify="space-between">
          <Col xs={{ span: 24 }} md={{ span: 18 }}>
            {getServicesData?.data?.getServices && list}
            {servicesList?.length > 0 && (
              <Pagination
                style={{ marginBottom: '10vh' }}
                current={currentPage}
                total={allPages}
                pageSize={1}
                defaultPageSize={allPages}
                showSizeChanger={false}
                itemRender={itemRender}
                showTotal={(total) => `Total: ${total} list`}
              />
            )}
          </Col>

          <Col md={{ span: 5 }}>
            <FilterContainer>
              <div>
                <h3>Filter services by:</h3>
                <Label>
                  <h3> Country</h3>
                </Label>
                <DropDown
                  values={options}
                  onChange={(e) => setCountry(e.target.value)}
                />
                <br />
                <Label>
                  <h3> Service category</h3>
                </Label>
                <InputDiv>
                  <Dropdown onChange={(e: any) => setCategory(e.target.value)}>
                    <Option value="">All Category</Option>
                    {categoryList?.map((categories: any) => (
                      <Option key={categories.id} value={categories.id}>
                        {categories.serviceCategory}
                      </Option>
                    ))}
                  </Dropdown>
                </InputDiv>
                <br />
                <Label>
                  <h3> Business Name</h3>
                </Label>
                <TextInput
                  placeholder="Type service name here..."
                  onChange={(e: any) => setBusinessName(e.target.value)}
                />
                <br />
                <Label>
                  <h3>City/State</h3>
                </Label>
                <TextInput
                  placeholder="Type city/state name here..."
                  onChange={(e: any) => setCity(e.target.value)}
                />
                <br />
                <LoggerButton
                  loading={loadingstate}
                  onClick={() =>
                    handleServiceSearch(
                      country,
                      category,
                      businessName,
                      city,
                      currentPage,
                    )
                  }
                  text="Search.."
                />
              </div>
            </FilterContainer>
          </Col>
        </Row>
      </BigContentContainer>
    </motion.div>
  )
}

export default Services
